module.exports = __webpack_public_path__ + "img/toChangePhoto.550040d4.png";